import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=0e7c9c2e&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7c9c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e7c9c2e')) {
      api.createRecord('0e7c9c2e', component.options)
    } else {
      api.reload('0e7c9c2e', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=0e7c9c2e&scoped=true&", function () {
      api.rerender('0e7c9c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8v8mtGChIa9zX/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports